export const educationData = [
  {
    id: 1,
    institution: "Federal Technological University of Paraná (UTFPR-CP)",
    course: "Software Engineering",
    startYear: "2019",
    endYear: "2023",
  },
];
